import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import {
  BAN_KINDS,
  COMMUNITY_MODERATION_PATH,
} from "@/domains/certifications/constants";
import { formatCertificationDate } from "@/domains/certifications/utils";
import { BanBannerProps } from "@/features/certifications/participant-detail/types";

import "../styles.css";

const BanBanner = ({ ban }: BanBannerProps) => {
  const { t } = useTranslation();
  const isTimed = ban.kind === BAN_KINDS.TIMED;

  return (
    <section
      className="participant-detail-ban flex flex-wrap items-start justify-between gap-300"
      aria-labelledby="participant-ban-title"
    >
      <div className="flex flex-col gap-100">
        <h2
          id="participant-ban-title"
          className="participant-detail-ban-title body-m-medium"
        >
          {isTimed
            ? t("certification.admin.participant.ban.timedTitle", {
                date: formatCertificationDate(ban.endsAt),
              })
            : t("certification.admin.participant.ban.permanentTitle")}
        </h2>

        <p className="body-s-regular">
          {t(
            isTimed
              ? "certification.admin.participant.ban.timedBody"
              : "certification.admin.participant.ban.permanentBody",
          )}
        </p>
      </div>

      {COMMUNITY_MODERATION_PATH && (
        <Link
          to={COMMUNITY_MODERATION_PATH}
          className="participant-detail-ban-link body-s-medium"
        >
          {t("certification.admin.participant.ban.manage")}
        </Link>
      )}
    </section>
  );
};

export default BanBanner;
